import { render } from "./pay-with-migo.vue?vue&type=template&id=0ebd19f0"
import script from "./pay-with-migo.vue?vue&type=script&lang=js"
export * from "./pay-with-migo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__